import styled from 'styled-components'

export const StyledTitleBar = styled.div`
    display: flex;
    flex: 1;
    padding: ${({ theme }) => `0 0 ${theme.spacing.xxSmall}`};
`
